import { defineStore } from 'pinia';
import moment from "moment";
import axios from 'axios'
import { handleError } from '../helpers';
export const useCrimeStore = defineStore('CrimeStore', {
    
    state: () => ({
        results: [],
        selectedCrime: null,
        loading: false,
        offenseDate: moment(new Date()).format("YYYY-MM-DD"),
        useSunset: false,
        categories: {},
    }),
    getters: {
        bodyObject(state) {
            return {
                search: null,
                offenseDate: state.useSunset ? new Date('01/01/1900') : state.offenseDate,
            }
        }
    },
    actions: {
        async loadCrimes(force){
            
            if ((this.results.length > 0 && !force) || this.loading) {
                this.loading = false;
                return this.results
            }
            this.loading = true
            const foundCrimes = await axios
                .post(process.env.VUE_APP_ENDPOINT + "/api/crimes/quickSearch", this.bodyObject, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                    },
                })
                .then((response) => {
                    // console.log(response)
                    this.results = response.data.crimes;
                    this.loading = false;    
                    // console.timeEnd()
                    return response.data
                })
                .catch(handleError);;
            await axios
                .get(process.env.VUE_APP_ENDPOINT + "/api/crimeCategories", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
                    },
                }).then(res => {
                    this.categories = res.data.categories
                    return res.data.categories
                })
            return foundCrimes
        },
    },
});
